// App.js
// Main Container

// Imports
import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import configureStore from '../config/configureStore';
import LocalStorage from '../config/LocalStorage';
import Home from './Home';
import Client from './Client';
import Product from './Product';
import Order from './Order';
import Report from './Report';
import Chart from './Chart';
import Navbar from './Navbar';

// Redux Store
const state = LocalStorage.LoadState();
const store = configureStore(state);
LocalStorage.ConfigureStore(store);

// Container Class
// Main container for application
class App extends Component {
  // Renders Container
  render() {
    return (
      <Provider store={store}>
        <Router>
          <div>
            <Navbar />
            <Route exact path="/" component={Home} />
            <Route path="/client" component={Client} />
            <Route path="/product" component={Product} />
            <Route exact path="/order" component={Order} />
            <Route path="/order/:clientId" component={Order} />
            <Route path="/chart" component={Chart} />
            <Route exact path="/report" component={Report} />
          </div>
        </Router>
      </Provider>
    );
  }
}

// Exports
export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js